{
    "app": {
        "title": "Dashbal",
        "common": {
            "defaultStoreName": "Votre boutique",
            "loading": "Chargement...",
            "unknown": "Inconnu"
        },
        "status": {
            "checking": "Vérification de l'état de la connexion...",
            "settingUpTitle": "Configuration de votre connexion",
            "settingUpDescription": "Nous connectons votre boutique à Dashbal. Cela ne prend généralement que quelques secondes.",
            "syncInProgress": "La synchronisation des données est en cours. Cela peut prendre quelques minutes selon la taille de votre boutique.",
            "dashbalAccount": "Compte Dashbal",
            "lastSynced": "Dernière synchronisation",
            "lastSyncedJustNow": "À l'instant",
            "lastSyncedMinute": "Il y a {{count}} minute",
            "lastSyncedMinute_plural": "Il y a {{count}} minutes",
            "lastSyncedHour": "Il y a {{count}} heure",
            "lastSyncedHour_plural": "Il y a {{count}} heures",
            "lastSyncedNever": "Jamais",
            "errorTitle": "Erreur de connexion",
            "errorDescription": "Un problème est survenu lors de la connexion de votre boutique. Veuillez réessayer ou contacter le support.",
            "notConnectedTitle": "Boutique non connectée",
            "notConnectedDescription": "Nous n'avons pas pu connecter votre boutique automatiquement. Veuillez réessayer. Si le problème persiste, contactez le support.",
            "active": "Actif",
            "syncing": "Synchronisation",
            "error": "Erreur",
            "disconnected": "Déconnecté",
            "pending": "En attente",
            "contactSupport": "contacter le support"
        },
        "connectionStatus": {
            "title": "État de la connexion",
            "store": "Boutique :"
        },
        "actions": {
            "openDashboard": "Ouvrir le tableau de bord Dashbal",
            "documentation": "Documentation",
            "retrySync": "Réessayer la synchronisation",
            "retrySetup": "Réessayer",
            "disconnect": "Déconnecter la boutique",
            "changePlan": "Changer de forfait"
        },
        "disconnect": {
            "title": "Déconnecter la boutique",
            "warning": "Êtes-vous sûr de vouloir déconnecter votre boutique ? Cela arrêtera la synchronisation des données. Vous pouvez vous reconnecter à tout moment en réinstallant l'application.",
            "confirm": "Déconnecter",
            "cancel": "Annuler",
            "accountLabel": "Compte : {{email}}",
            "error": "Échec de la déconnexion de la boutique"
        },
        "setup": {
            "title": "Comment ça marche",
            "step1": "Entrez l'e-mail de votre compte Dashbal pour lier votre boutique",
            "step2": "Entrez le code d'autorisation à 6 chiffres envoyé à votre adresse e-mail",
            "step3": "Vos données commenceront à se synchroniser automatiquement une fois connectées"
        },
        "whatNext": {
            "title": "Que pouvez-vous faire",
            "description": "Les données de votre boutique sont en cours de synchronisation avec Dashbal. Ouvrez le tableau de bord pour accéder aux analyses en temps réel, aux rapports financiers et aux informations sur votre entreprise."
        },
        "quickLinks": {
            "title": "Liens rapides"
        },
        "settings": {
            "title": "Paramètres",
            "description": "Gérez la connexion de votre boutique et les paramètres d'intégration.",
            "billedViaWebsite": "La facturation est gérée sur votre compte Dashbal."
        },
        "support": {
            "title": "Support",
            "contactSupport": "Contacter le support"
        },
        "errors": {
            "connectionCheckFailed": "Échec de la vérification de l'état de la connexion",
            "shopNotDetected": "Impossible de détecter votre boutique. Veuillez accéder à cette application depuis l'administration Shopify.",
            "setupTimeout": "Le délai de configuration de la connexion a expiré. Veuillez réessayer.",
            "setupFailed": "Échec de la configuration de la connexion",
            "emailRequired": "L'adresse e-mail est requise.",
            "otpRequired": "L'adresse e-mail et le code d'autorisation sont requis.",
            "otpSendFailed": "Échec de l'envoi du code d'autorisation.",
            "verifyFailed": "Échec de la vérification du code et de la connexion"
        },
        "notConnected": {
            "title": "Configurer le compte Dashbal",
            "enterEmail": "Entrez votre e-mail pour connecter cette boutique. Nous lierons votre compte Dashbal — ou en créerons un pour vous si vous n'en avez pas encore.",
            "checkEmail": "Vérifiez votre boîte de réception pour le code d'autorisation à 6 chiffres.",
            "checkEmailNewAccount": "Nous avons envoyé un code à 6 chiffres à votre e-mail. Saisissez-le pour créer votre compte Dashbal et connecter cette boutique.",
            "emailLabel": "E-mail Dashbal",
            "emailHelp": "Nous enverrons un code d'autorisation pour vérifier cet e-mail.",
            "otpLabel": "Code d'autorisation à 6 chiffres",
            "otpHelp": "Entrez le code envoyé à votre adresse e-mail.",
            "requestButton": "Envoyer le code de vérification",
            "linkButton": "Lier le compte",
            "verifyButton": "Vérifier et connecter",
            "cancelButton": "Changer d'e-mail"
        }
    },
    "billing": {
        "loading": "Chargement des forfaits…",
        "pickerTitle": "Choisissez votre forfait Dashbal",
        "subscribe": "S'abonner",
        "continueFree": "Continuer avec Gratuit",
        "freeBadge": "Aucun paiement requis",
        "freePrice": "Gratuit pour toujours",
        "month": "mois",
        "trialBadge": "Essai gratuit de {{days}} jours",
        "includedStores": "Inclut jusqu'à {{count}} boutique Shopify connectée",
        "includedStores_plural": "Inclut jusqu'à {{count}} boutiques Shopify connectées",
        "legalCharge": "Les frais apparaissent sur votre facture Shopify. En vous abonnant, vous acceptez les conditions de service de Dashbal.",
        "activating": "Activation de votre abonnement…",
        "activationFailed": "Nous n'avons pas pu confirmer votre abonnement. Veuillez actualiser dans un instant.",
        "retry": "Réessayer",
        "openDashbal": "Ouvrir Dashbal",
        "activeBadge": "Actif",
        "billingViaShopify": "Facturé via Shopify",
        "currentPlanBadge": "Forfait actuel",
        "previousPlanBadge": "Votre forfait précédent",
        "resubscribe": "Se réabonner",
        "alreadyOnPlan": "Déjà sur ce forfait",
        "backToApp": "Retour à l'app",
        "websiteSubscriptionTitle": "Tout est prêt",
        "websiteSubscriptionActive": "Votre abonnement est actif sur votre compte Dashbal. Aucun paiement n'est requis dans cette application — cette boutique est couverte par votre forfait existant.",
        "activeOnOtherStore": "Ce compte Dashbal possède déjà un abonnement actif sur une autre boutique Shopify. Annulez-le là-bas avant de vous abonner sur cette boutique."
    }
}
